<template>
  <div class="modelPlay-wrap" v-show="showPlay">
    <div class="play-con" ref="playCon">
      <div class="play-mask" v-if="parseInt(playType) !== 4"></div>
      <!-- 一级模型-模型 -->
      <div class="models" v-if="parseInt(playType) === 1">
        <div class="contain">
          <img class="close" src="./../../../../assets/images/close.png" alt="" @click="closeModel"/>
          <div id="container" ref="ray"
            :style="{
              'background-image':'url(' + aliOsUrl(playData.bgSrc) + ')',
              'background-size': '100% 100%',
              'background-repeat': 'no-repeat'
            }">
          </div>
        </div>
      </div>
      <!-- 一级视频 -->
      <div class="video" v-if="parseInt(playType) === 2 && showPlay">
        <video
         ref="videoPlayer1"
         :src="aliOsUrl(playData.src, 2)"
         autoplay
         controls
         controlslist="nodownload noremoteplayback"
         :disablePictureInPicture="true" webkit-playsinline playsinline x5-video-player-type="h5-page"></video>
        <img class="close" src="./../../../../assets/images/close.png" alt="" @click="closeModel"/>
      </div>
      <!-- 一级音频 -->
      <div class="audio" v-if="parseInt(playType) === 3 && showPlay">
        <div class="audio-contain">
          <audio width="100%" ref="audioPlayer" :src="aliOsUrl(playData.src, 3)" autoplay controls id="audioPlayer" @pause="audioControl('stop')" @play="audioControl('play')"></audio>
          <img class="close" src="./../../../../assets/images/close.png" alt="" @click="closeModel"/>
        </div>
      </div>

      <!-- 特殊二级详情 -->
      <div class="closeContain" v-if="parseInt(playType) === 4">
        <div class="closeItem">
          <img src="@/assets/images/common/left_icon.png" alt="" @click="closeModel">
          <!-- <img class="close" src="./../../../../assets/images/close.png" alt="" @click="closeModel"/> -->
        </div>
      </div>
      <div class="paly-contain">
        <div class="center-contain" v-if="parseInt(playType) === 4">
          <img
            :src="aliOsUrl(playData.src, 4)"
            alt=""
            v-show="playData.hasOwnProperty('imageId')"
          />
          <video class="video-contain"
            ref="videoPlayer2"
            :src="aliOsUrl(playData.src, 4)"
            autoplay
            controls
            controlslist="nodownload noremoteplayback"
            :disablePictureInPicture="true"
            v-show="playData.hasOwnProperty('videoId')"
            webkit-playsinline playsinline x5-video-player-type="h5-page"
          ></video>
          <div id="container1"  ref="ray" v-show="playData.hasOwnProperty('modelId')"
          :style="{
                    'background-image':'url(' + aliOsUrl(playData.bgSrc) + ')',
                    'background-size': '100% 100%',
                    'background-repeat': 'no-repeat'
                  }">
          </div>
        </div>
        <div class="top-actical" v-if="parseInt(playType) === 4">
          <div class="show-wrap">
            <div class="name">{{ playData.name }}</div>
            <div class="text-wrap">
              <div class="introduce">
                <div class="content" ref="content">
                  <div class="description" v-html="playData.description"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom-relative" v-if="playData.hasOwnProperty('modelId') && relaticeList.length>0">
          <div class="line"><div class="icon"></div>相关推荐</div>
          <div class="relative-content">
            <ul>
              <li v-for='(item,index) of relaticeList' :key='index' @click='changeModel(item)'>
                <div class="img-box">
                  <img :src="aliOsUrl(item.coverImage, 4)" alt="">
                </div>
                <div class="relaname">{{item.name}}</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { course, aliyun } from '@/agent'
export default {
  model: {
    prop: 'showPlay',
    event: 'change'
  },
  // showPlay:是否显示播放器  playDatas: 播放内容  playType: 播放类型 1模型 2视频 3音频  id: 模型id
  props: ['showPlay', 'playDatas', 'id', 'playType', 'modelName', 'chapterId'],
  data () {
    return {
      isInerFrame: true, // 是否是初始化iframe
      /** 模型路径 */
      normal: '', // 法线贴图
      camera: null,
      scene: null,
      renderer: null,
      mesh: null,
      controls: '',
      relaticeList: [], // 相关推荐列表
      audioPlay: '',
      mixers: [],
      clock: new THREE.Clock(),
      modelType: 0,
      playData: ''
    }
  },
  watch: {
    showPlay (val) {
      if (val) {
        this.playData = this.playDatas
        switch (parseInt(this.playType)) {
          case 1: { // 一级界面-模型
            console.log('11111111111')
            this.isInerFrame = false
            this.init('container', this.playData.type)
            break
          }
          case 2: { // 一级界面-视频
            console.log('2222222222')
            break
          }
          case 3: { // 一级界面-音频
            console.log('333333333333')
            this.$refs.audioPlayer = true
            break
          }
          case 4: { // 二级界面-详情（模型、图片、视频）
            console.log('444444444444')
            if (this.playData.modelId) {
              this.init('container1', this.playData.type)
              this.audioPlay = new Audio(this.$util.aliOsUrl(this.playData.bindAudioSrc))
              this.audioPlay.play()
              this.getRelativeList()
            }
            break
          }
        }
      }
    }
  },
  mounted: function () {
  },
  beforeDestroy () {
    this.$emit('change', false)
  },
  methods: {
    /**
       * 音频播放、暂停事件
       * @param type stop 暂停 play 播放
       */
    audioControl (type) {
      this.$refs.audioPlayer = type
      let audioPlaySte = false
      if (type === 'stop') {
        audioPlaySte = false
      } if (type === 'play') {
        audioPlaySte = true
      }
      this.$refs.audioPlayer = audioPlaySte
    },
    /**
       * 关闭弹窗
      */
    closeModel () {
      this.$emit('change', false)
      switch (parseInt(this.playType)) {
        case 1: { // 一级界面-模型
          console.log('11111111111')
          document.getElementById('container').innerHTML = ''
          // document.querySelector('.play-con').querySelector('iframe').contentWindow.postMessage(JSON.stringify({ type: 'reset' }), '*')
          break
        }
        case 2: { // 一级界面-视频
          console.log('2222222222')
          this.$refs.videoPlayer1.pause()
          break
        }
        case 3: { // 一级界面-音频
          console.log('333333333333')
          this.$refs.audioPlayer = false
          break
        }
        case 4: { // 二级界面-详情（模型、图片、视频）
          console.log('444444444444')
          document.getElementById('container1').innerHTML = ''
          this.$refs.videoPlayer2.pause()
          this.relaticeList = []
          break
        }
      }
    },
    /**
     * 生成模型场景的步骤
     */
    init (nodename, type) {
      this.modelType = this.playData.modelType
      // 模型
      const obj = {
        id: this.id,
        token: JSON.parse(localStorage.getItem('US_INFO'))
          ? JSON.parse(localStorage.getItem('US_INFO')).token
          : '',
        attachs: this.playData.attachs,
        url: this.playData.modelFormat === 1 ? this.aliOsUrlModel(this.playData.attachs[0].src) : this.aliOsUrlModel(this.playData.src),
        albedo: this.aliOsUrlModel(this.playData.albedo),
        normal: this.aliOsUrlModel(this.playData.normal),
        metallic: this.aliOsUrlModel(this.playData.metallic),
        rightBgSrc: this.aliOsUrl(this.playData.rightBgSrc),
        leftBgSrc: this.aliOsUrl(this.playData.leftBgSrc),
        upBgSrc: this.aliOsUrl(this.playData.upBgSrc),
        downBgSrc: this.aliOsUrl(this.playData.downBgSrc),
        backBgSrc: this.aliOsUrl(this.playData.backBgSrc),
        frontBgSrc: this.aliOsUrl(this.playData.frontBgSrc),
        type: this.playData.type,
        modelFormat: this.playData.modelFormat, // 模型格式
        scaling: this.playData.scaling,
        modelType: this.playData.modelType // 是动态模型还是静态模型
      }
      setTimeout(() => {
        this.initScene(obj)
        this.initCamera(obj, nodename) // 相机
        this.initWebGLRenderer(nodename, type)// 渲染器
        this.initAxisHelper()// 辅助坐标
        this.createControls(nodename)// 控件对象
        this.render()
      }, 10)
    },

    // 获取相关推荐列表
    getRelativeList () {
      course.getRelativeList(this.chapterId, Number(this.playData.modelId), {}).then((res) => {
        if (res.code == 100) {
          this.relaticeList = res.data
        }
      })
    },
    // 切换模型中的推荐模型
    changeModel (item) {
      document.getElementById('container1').innerHTML = ''
      this.playData = item
      this.init('container1', this.playData.type)
      this.audioPlay = new Audio(this.$util.aliOsUrl(this.playData.bindAudioSrc))
      this.audioPlay.play()
    },
    // 创建场景对象Scene
    initScene (obj) { // 颜色纹理 ,法线贴图 ,金属度
      const that = this
      that.scene = new THREE.Scene()
      // 默认您已经创建了相机和渲染器，就直接在场景上加入背景就行
      if (obj.type === 2) {
        that.scene.background = new THREE.CubeTextureLoader().load([obj.rightBgSrc, obj.leftBgSrc, obj.upBgSrc, obj.downBgSrc, obj.backBgSrc, obj.frontBgSrc])// 添加天空盒子背景图
      }

      // 环境光
      const ambient = new THREE.AmbientLight(0xffffff)
      ambient.color = new THREE.Color('#cccccc')
      that.scene.add(ambient)

      // 点光源
      const point = new THREE.PointLight(0xffffff)
      point.position.set(400, 200, 300) // 点光源位置
      // 通过add方法插入场景中，不插入的话，渲染的时候不会获取光源的信息进行光照计算
      that.scene.add(point) // 点光源添加到场景中

      // 点光源2  位置和point关于原点对称
      const point2 = new THREE.PointLight(0xffffff)
      point2.position.set(-400, -200, -300) // 点光源位置
      that.scene.add(point2) // 点光源添加到场景中

      // 定向光
      const directionalLight = new THREE.DirectionalLight(0xffffff, 0.5)
      that.scene.add(directionalLight)

      if (obj.modelFormat === 1) {
        // 加载GLTF模型
        const gltfLoder = new GLTFLoader()
        gltfLoder.load(obj.url, function (gltf) {
          gltf.scene.scale.set(1 * 50, 1 * 50, 1 * 50)
          gltf.scene.traverse(function (child) {
            if (child.isMesh) {
              child.material.emissive = child.material.color
              child.material.emissiveMap = child.material.map
            }
          })
          if (obj.modelType === 2) {
            that.mixers = new THREE.AnimationMixer(gltf.scene)
            const action = that.mixers.clipAction(gltf.animations[0])
            action.play()
          }
          that.scene.add(gltf.scene)
        }, function (e) {
          console.log(e)
        })
      } else {
      // 纹理贴图 创建一个纹理加载器
        const TextureLoader = new THREE.TextureLoader()
        // 加载FBX模型
        const texturePlante = new THREE.TextureLoader().load(obj.albedo)
        const fbxLoader = new FBXLoader()
        fbxLoader.load(obj.url, function (object) { // fbx模型
          object.traverse(function (child) {
            const material = new THREE.MeshPhongMaterial({
              map: texturePlante
            })
            child.material = material

            // // 加载法线贴图，表面细节更丰富
            const textureNormal = TextureLoader.load(obj.normal)
            child.material.normalMap = textureNormal

            // 设置高光贴图，一个网格模型不同的区域反射光线的能力不同
            const textureSpecular = TextureLoader.load(obj.metallic)
            child.material.specularMap = textureSpecular
            child.material.specular.set(0xffffff) // 高光反射颜色
            child.material.shininess = 15 // 高光高亮程度，默认30
            //  that.mesh = object
            if (child.isMesh) {
              child.castShadow = true
              child.receiveShadow = true
            }
            that.scene.add(object)
          })
        })
      }
    },
    // 相机
    initCamera (obj, nodename) {
      const container = document.getElementById(nodename)
      this.camera = new THREE.PerspectiveCamera(60, container.clientWidth / container.clientHeight, 1, 1000)
      // console.log(obj.scaling)
      switch (obj.scaling) {
        case 0:
          this.camera.position.set(100, 100, 100)
          break
        case 10:
          this.camera.position.set(95, 95, 95)
          break
        case 20:
          this.camera.position.set(80, 80, 80)
          break
        case 30:
          this.camera.position.set(75, 75, 75)
          break
        case 40:
          this.camera.position.set(70, 70, 70)
          break
        case 50:
          this.camera.position.set(65, 65, 65)
          break
        case 60:
          this.camera.position.set(60, 60, 60)
          break
        case 70:
          this.camera.position.set(55, 55, 55)
          break
        case 80:
          this.camera.position.set(50, 50, 50)
          break
        case 90:
          this.camera.position.set(45, 45, 45)
          break
        case 100:
          this.camera.position.set(40, 40, 40)
          break
      }
      this.camera.lookAt(this.scene.position) // 设置相机方向(指向的场景对象)
    },
    // 创建渲染器对象
    initWebGLRenderer (nodename, type) {
      // type 1是背景 2 是天空盒
      if (type === 1) {
        // 设置背景图
        const container = document.getElementById(nodename)
        this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true })
        this.renderer.setClearAlpha(0.2)
        this.renderer.setSize(container.clientWidth, container.clientHeight) // 设置渲染区域尺寸

        // this.renderer.setClearColor(0xb9d3ff, 1); //设置背景颜色
        container.appendChild(this.renderer.domElement)// body元素中插入canvas对象
      } else {
        // 不设置背景图
        const container = document.getElementById(nodename)
        this.renderer = new THREE.WebGLRenderer({ antialias: true })
        this.renderer.setSize(container.clientWidth, container.clientHeight) // 设置渲染区域尺寸
        container.appendChild(this.renderer.domElement)// body元素中插入canvas对象
      }
    },
    // 辅助三维坐标系AxisHelper
    initAxisHelper () {
      this.axisHelper = new THREE.AxisHelper(250)

      // this.scene.add(this.axisHelper)
    },
    // 创建控件对象
    createControls (nodename) {
      this.controls = new OrbitControls(this.camera, this.renderer.domElement)
      const ctx = document.getElementById(nodename)
      const child = ctx.firstChild
      let a = 0
      child.addEventListener('wheel', (e) => {
        this.controls.enableZoom = true
        if (e.wheelDelta > 0) {
          if (a <= 5) {
            a = a + 1
          }
        } else if (e.wheelDelta < 0) {
          if (a >= -10) {
            a = a - 1
          }
        }
        if (a > 5 || a < -10) {
          this.controls.enableZoom = false
        }
      })
    },
    // 执行渲染
    render () {
      const that = this
      requestAnimationFrame(this.render) // 请求再次执行渲染函数render
      if (that.modelType === 2) {
        const delta = that.clock.getDelta()
        if (that.mixers) that.mixers.update(delta)
        that.controls.update()
      }
      this.renderer.render(this.scene, this.camera)// 执行渲染操作
    },
    // 网格
    initGrid () {
      const gridHelper = new THREE.GridHelper(2, 50, 0xff00ff, 0x808080)
      this.scene.add(gridHelper)
    },
    /**
     * ali云os地址拼接
     * @param value oss地址
    */
    aliOsUrl  (path) {
      return aliyun.getAliyunAddress(path)
    },
    aliOsUrlModel  (path) {
      return aliyun.getAliOsUrlModel(path)
    },
  }
}
</script>
<style  lang="scss">
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0s;
  }
  .fade-enter, .fade-leave-to{
    opacity: 0;
  }
  .modelPlay-wrap{
    body{
      background: none;
    }

    .models{
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: 6002;
      top: 3%;
      left: 0;
      right: 0;
      margin: auto;
      .contain{
        .close{
          position: absolute;
          width: 16px;
          height: 16px;
          right: 10px;
          top: -14px;
        }
        padding: 0 20px;
        box-sizing: border-box;
        width: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        #container{
          height: 340px;
          border-radius: 10px;
          overflow: hidden;
        }
      }
    }
    .play-con{
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      margin-top: auto !important;
      padding: 0;
      background: none;
      z-index: 3000;
      background: #1d1e1f;
      .play-mask{
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        margin-top: auto !important;
        padding: 0;
        background: rgba(0,0,0,0.8);
        z-index: 2000;
      }
      .paly-contain{
        overflow: scroll;
        height: 100%;
        box-sizing: border-box;
        padding-bottom: 30px;
        .top-actical{
          width: 100%;
          // min-height: 160px;
          padding: 0 20px;
          box-sizing: border-box;
          margin-bottom: 40px;
          .name{
            opacity: 1;
            font-size: 24px;
            font-family: YouSheBiaoTiHei, YouSheBiaoTiHei-Regular;
            font-weight: 400;
            text-align: left;
            color: #ffffff;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .content{
            margin-top: 23px;
            opacity: 1;
            font-size: 12px;
            font-family: Source Han Sans CN, Source Han Sans CN-Normal;
            font-weight: Normal;
            text-align: left;
            color: #828282;
            line-height: 18px;
            .description>p{
              text-indent: 25px;
              margin-bottom: 20px;
            }
          }
        }
        .center-contain {
          width: 100%;
          min-height: 210px;
          margin-bottom: 30px;
          #container1{
            height: 400px;
          }
          img{
            width: 100%;
            height: auto;
          }
          .video-contain{
            width: 100%;
            height: auto;

          }
        }
        .bottom-relative{
          margin-bottom: 30px;
          padding: 0 20px;
          .line{
            opacity: 1;
            font-size: 15px;
            font-family: Source Han Sans CN, Source Han Sans CN-Medium;
            font-weight: 500;
            text-align: left;
            color: #f2f2f2;
            line-height: 15px;
            display: flex;
            margin-bottom: 20px;
            .icon{
              width: 2px;
              height: 15px;
              opacity: 1;
              background: #e50914;
              border-radius: 1px;
              margin-right: 8px;
            }
          }
          .relative-content{
            ul{
              width: 100%;
              display: flex;
              justify-content: space-between;
              flex-wrap: wrap;
              li{
                width: 164px;
                height: 150px;
                opacity: 1;
                background: #252525;
                border-radius: 2px;
                margin-bottom: 7px;
                img{
                  max-width: 100px;
                  margin: 0 auto;
                  display: block;
                }
                .relaname{
                  height: 15px;
                  opacity: 1;
                  font-size: 15px;
                  font-family: Source Han Sans CN, Source Han Sans CN-Regular;
                  font-weight: 400;
                  text-align: center;
                  color: #828282;
                  line-height: 15px;
                  letter-spacing: 0px;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
                  margin: 20px 0;
                }
              }
            }
          }

        }
      }
    }
    iframe{
      position: relative;
      z-index: 6000;
      width: 100%;
      height: 100%;
      border:none;
    }

    .video{
      position: absolute;
      left:0;
      right: 0;
      top:0;
      bottom: 0;
      margin: auto;
      z-index: 6000;
      width: 100%;
      height: 200px;
      video{
        position: absolute;
        top:50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 90%;
        height: 100%;
        background: #fff;
      }
      .close{
        position: absolute;
        width: 16px;
        height: 16px;
        left: 92.5%;
        top: -8.5%;
      }
    }
    .audio {
      position: absolute;
      left:0;
      right: 0;
      top:0;
      bottom: 0;
      margin: auto;
      z-index: 6000;
      width: 300px;
      height: 54px;
      animation: audioMove 1s ease;
      .audio-contain{
        position: relative;
        width: 100%;
        height: 100%;
      }
      audio#audioPlayer {
        width: 300px;
        height: 54px;
      }
      .close{
        position: absolute;
        top: 50%;
        left: 100%;
        transform: translate(20%,-50%);
        margin:0;
        width: 16px;
        height: 16px;
      }
    }
    .closeContain{
      width: 100%;
      height: 40px;
      background: #ffffff;
      z-index: 6002;
      .closeItem {
        width: 40px;
        height: 40px;
        padding: 12px 20px;
        img{
          width: 9px;
          height: 16px;
          display: block;
          cursor: pointer;
        }
      }
    }
  }
  @keyframes audioMove {
      from {top:-100%;}
      to {top:0px;}
  }
  @-webkit-keyframes audioMove {
      from {top:-100%;}
      to {top:0px;}
  }
</style>
